import RightChart from './RightChart';

export default RightChart;
